import React from 'react';
import { ChatWindow } from './components/testing/ChatWindow';

export const WorkflowTesting = () => {

    return (
        <div className="workflow-testing">
            <ChatWindow />
        </div>
    );
}